export default __webpack_public_path__ + "static/media/support.f91d9278.svg";